export default __webpack_public_path__ + "static/LoginBGImage-7ccec083434b2f3ee0f9e43c7cf59e62.png";